import { useEffect, useState } from 'react';

/**
 * Get a data asynchronously.
 * @param getSnapshot retrieves data asynchronously
 * @returns the data
 */
function useData<T>(getSnapshot: () => Promise<T>, deps: Array<any> = []) {
    const [data, setData] = useState<T>();

    useEffect(() => {
        // Freshness guard: when `deps` change quickly (e.g. the free-play screen
        // switching games), several fetches are in flight at once and may resolve
        // OUT OF ORDER. Without this guard, a slow earlier fetch can resolve AFTER a
        // newer one and overwrite it → the UI shows the previous value ("décalage
        // d'un cran"). The cleanup flips `alive` to false so any in-flight response
        // from a superseded effect run is ignored. See gotcha #86.
        let alive = true;
        getSnapshot()
            .then((d: T) => {
                if (alive) setData(d);
            })
            .catch((error) => {
                // Do NOT rethrow here: throwing inside a `.then` chain produces an
                // unhandled promise rejection (it never reaches a React error
                // boundary). Log it instead.
                if (alive) console.error('[useData] fetch failed', error);
            });
        return () => {
            alive = false;
        };
    }, deps);

    return data;
}

export default useData;
